const URL = '/track';

export const trackView = async (clickID: string, referrer: string): Promise<void> => {
  const viewUrl = `${URL}/view?clickid=${clickID}&referrer=${referrer}`;
  try {
    await fetch(viewUrl);
  } catch (error: unknown) {
    if (import.meta.dev) {
      // eslint-disable-next-line no-console
      console.error('Click id track view ERROR', error);
    }
  }
};
